import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedVendingTransaction, ExtendedVendingTransactionListResponse, ExtendedVendingTransactionQueryParams } from '@frontend/transaction/types';

export class TransactionVendingClient extends APIClient {
    public static readonly endpoint = '/transaction-api/ext/v1';

    public static async getConsumptions(queryParams?: ApiQueryParams<ExtendedVendingTransactionQueryParams>): Promise<ExtendedVendingTransactionListResponse> {
        return this.apiPaginated<ExtendedVendingTransactionListResponse, ExtendedVendingTransactionQueryParams>(`${this.endpoint}/consumptions`, queryParams);
    }

    public static async getReplenishments(
        queryParams?: ApiQueryParams<ExtendedVendingTransactionQueryParams>
    ): Promise<ExtendedVendingTransactionListResponse> {
        return this.apiPaginated<ExtendedVendingTransactionListResponse, ExtendedVendingTransactionQueryParams>(`${this.endpoint}/replenishments`, queryParams);
    }

    public static async getReturns(queryParams?: ApiQueryParams<ExtendedVendingTransactionQueryParams>): Promise<ExtendedVendingTransactionListResponse> {
        return this.apiPaginated<ExtendedVendingTransactionListResponse, ExtendedVendingTransactionQueryParams>(`${this.endpoint}/returns`, queryParams);
    }

    public static async getRecycles(queryParams?: ApiQueryParams<ExtendedVendingTransactionQueryParams>): Promise<ExtendedVendingTransactionListResponse> {
        return this.apiPaginated<ExtendedVendingTransactionListResponse, ExtendedVendingTransactionQueryParams>(`${this.endpoint}/recycles`, queryParams);
    }

    public static async getVendingTransactions(
        queryParams?: ApiQueryParams<ExtendedVendingTransactionQueryParams>
    ): Promise<ExtendedVendingTransactionListResponse> {
        return this.apiPaginated<ExtendedVendingTransactionListResponse, ExtendedVendingTransactionQueryParams>(
            `${this.endpoint}/vending-transactions`,
            queryParams
        );
    }

    public static async fetchVendingTransaction(accountId: string, transactionId: string): Promise<ExtendedVendingTransaction> {
        const res = await this.fetch(`${this.endpoint}/accounts/${accountId}/vending-transactions/${transactionId}`);
        return await this.handleResponse<ExtendedVendingTransaction>(res);
    }
}
